import { ReactNode } from "react";
import { PageContainer } from "./page-container";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import { useConfirmation } from "@/context/ConfirmationContext";

interface PageContentProps {
  children: ReactNode;
}

export function PageContent({ children }: PageContentProps) {
  const { confirmationProps, hideConfirmation } = useConfirmation();

  return (
    <PageContainer>
      {confirmationProps && (
        <ConfirmationDialog
          open={true}
          onCancel={hideConfirmation}
          onConfirm={() => {
            confirmationProps.onConfirm();
            hideConfirmation();
          }}
          title={confirmationProps.title}
          description={confirmationProps.description}
          confirmText={confirmationProps.confirmText}
          cancelText={confirmationProps.cancelText}
        />
      )}
      {children}
    </PageContainer>
  );
}
